import { Controller } from "@hotwired/stimulus";

const COLLAPSE_KEY = "admin_sidebar_collapsed";

export default class extends Controller {
  static targets = ["sidebar", "overlay"];

  connect() {
    this.isOpen = false;
    this.applyTitlesFromLabels();
  }

  applyTitlesFromLabels() {
    // Po renderze: kopiuj tekst .sidebar-label do title= linka, żeby zwinięty sidebar
    // miał natywne tooltips na hover.
    document.querySelectorAll(".sidebar-link").forEach((link) => {
      if (link.title) return;
      const label = link.querySelector(".sidebar-label");
      if (label) link.title = label.textContent.trim();
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.sidebarTarget.classList.remove("-translate-x-full");
    this.sidebarTarget.classList.add("translate-x-0");
    this.overlayTarget.classList.remove("hidden", "opacity-0");
    this.overlayTarget.classList.add("opacity-100");
    document.body.classList.add("overflow-hidden", "lg:overflow-auto");
  }

  close() {
    this.isOpen = false;
    this.sidebarTarget.classList.add("-translate-x-full");
    this.sidebarTarget.classList.remove("translate-x-0");
    this.overlayTarget.classList.add("opacity-0");
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden");
    }, 200);
    document.body.classList.remove("overflow-hidden", "lg:overflow-auto");
  }

  // Close on Escape key
  closeOnEscape(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close();
    }
  }

  // Desktop: zwiń sidebar do samych ikon. Stan trzymany w localStorage + data-attribute na <html>.
  toggleCollapse() {
    const root = document.documentElement;
    const collapsed = root.dataset.sidebar === "collapsed";
    if (collapsed) {
      root.dataset.sidebar = "expanded";
      localStorage.setItem(COLLAPSE_KEY, "false");
    } else {
      root.dataset.sidebar = "collapsed";
      localStorage.setItem(COLLAPSE_KEY, "true");
    }
  }
}
